import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { showModal } from "../../../reducers/modal/modal.actions";
import { updateAnggota } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../../store/errorHandler";
import { PermissionMenuName } from "../../../interfaces/UserRole";
import { allowSave } from "../../../store/helpers";

export const FormAnggota = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state: RootState) => state.dokumenKerjasama.error);
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const anggota = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.ANGGOTA);
  const [listAnggota, setListAnggota] = useState<string[]>([]);
  const [txtNewAnggota, setTxtNewAnggota] = useState<string>("");
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);
  const canSave = allowSave(role, 2);

  useEffect(() => {
    if (anggota) {
      const newListAnggota = anggota.split(',');
      setListAnggota(newListAnggota);
    } else {
      setListAnggota([]);
    }
  }, [anggota]);

  const onChangeTxtNewAnggota = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTxtNewAnggota(e.target.value);
  }

  const addAnggota = () => {
    if (!txtNewAnggota.trim()) {
      dispatch(showModal('Nama anggota tidak boleh kosong!', 'Mohon masukkan nama anggota terlebih dahulu.'));
      return;
    }
    const newListAnggota = listAnggota;
    newListAnggota.push(txtNewAnggota);
    dispatch(updateAnggota(newListAnggota.join(",")));
    setTxtNewAnggota("");
  }

  const removeAnggota = (index: number) => {
    const newListAnggota = [...listAnggota];
    if (newListAnggota.length > 1) {
      newListAnggota.splice(index, 1);
      dispatch(updateAnggota(newListAnggota.join(",")));
    } else {
      dispatch(updateAnggota(""));
    }
  }

  const renderListAnggota = () => {
    if (listAnggota.length === 0) {
      return (
        <tr>
          <td colSpan={2} style={{textAlign: 'center'}}>
            Data tidak ditemukan, silahkan tambah anggota baru.
          </td>
        </tr>
      );
    }

    return listAnggota.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item}</td>
          <th>
            <button className="btn btn-danger btn-xs" disabled={isLoading || !canSave} onClick={() => removeAnggota(index)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      );
    })
  }

  if (typeof anggota === 'undefined') return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Anggota Kerjasama</h3>
        </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
  
  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Anggota Kerjasama</h3>
        </div>
        <div className="box-body">
          <div className={`form-group ${fieldHasErrors('ANGGOTA', errors) ? 'has-error' : ''}`}>
            <label>Masukkan nama anggota</label>
            <div className="input-group">
              <input
                type="text"
                disabled={isLoading || !canSave}
                className="form-control"
                value={txtNewAnggota}
                onChange={onChangeTxtNewAnggota}
              />
              <span className="input-group-btn">
                <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={addAnggota}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <span className="help-block">{ fieldErrorMessage('ANGGOTA', errors) }</span>
          </div>
        </div>
        <div className="box-body table-responsive no-padding" style={{ maxHeight: '200px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="sticky">Nama <span className="text-red"><b>*</b></span></th>
                <th className="sticky"></th>
              </tr>
            </thead>
            <tbody>
              {renderListAnggota()}
              </tbody>
          </table>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
